import { DynamicFieldProps } from 'src/components/DynamicForm/DynamicForm'

import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    postalCode: Yup.string().required('Postal code is required'),
    streetAddress: Yup.string().required('Street address is required'),
  })
